/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { ExpandMore, RestartAlt, ZoomIn, ZoomOut } from "@mui/icons-material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import _ from "lodash";
import ClearIcon from "@mui/icons-material/Clear";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Select,
  FormHelperText,
  MenuItem,
  Button,
  Alert,
  Box,
  Snackbar,
  FormControlLabel,
  Checkbox,
  Avatar,
  Modal,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  FormGroup,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import { connect } from "react-redux";
import DocumentUpload from "../components/DocumentUpload";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";
import moment from "moment";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Mob = styled.div`
  ${(props) => props.theme.breakpoints.down("md")} {
    display: none;
  }
`;

const getCompanyProfile = async (company, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/customer_company/${company}`,
      config
    );
    const profile = data.data;
    if (data.success) {
      setMyState((prev) => {
        return { ...prev, profile: data.data };
      });
    }

    const plateData = await axios.get(
      `/api/v1/${authData?.type}/customer_company/${profile._id}/plate`,
      config
    );
    if (plateData.data.success) {
      setMyState((prev) => {
        return { ...prev, plateDetails: plateData.data.data.data };
      });
    }

    const audit = await axios.get(
      `/api/v1/${authData?.type}/customer_company/${company}/audit_logs`,
      config
    );
    if (audit.data.success) {
      setMyState((prev) => {
        return { ...prev, audits: audit.data.data };
      });
    }

    if (data.success) {
      setLinks(data.data.documents, setMyState);
    }
    // setLoader(false);
  } catch (e) {
    setMyState((prev) => {
      return { ...prev, loader: false };
    });
  }
};

const getUrls = async (documents, setUrls, setLoader) => {
  try {
    setLinks(documents, setUrls, setLoader);
  } catch (e) {
    console.log(e);
    setLoader(false);
  }
};

const setLinks = (document, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let urls = [];
    document.map((doc) => {
      const type = doc?.document_storage_info?.key?.split(".")[1];
      urls.push({
        url: `/api/v1/${authData?.type}/media/${doc.document_storage_info.key}`,
        name: doc.document_title,
        type: type,
        key: doc?.document_storage_info?.key,
      });
    });
    sendRequests(urls, setMyState);
  } catch (e) {
    console.log(e);
  }
};

const sendRequests = async (urls, setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    let num = urls.length;
    if (num === 0) {
      setMyState((prev) => {
        return { ...prev, loader: false };
      });
    }
    let n = 0;
    let allUrls = [];
    let promiseArr = urls.map((l) => {
      let PROD_URL = "";
      if (process.env.NODE_ENV === "development") {
        PROD_URL = process.env.REACT_APP_BACKEND_DEV_API_URL;
      } else {
        PROD_URL = process.env.REACT_APP_BACKEND_PRODUCTION_API_URL;
      }
      fetch(PROD_URL + l.url, {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
        method: "GET",
      })
        .then(async (resp) => {
          return resp.arrayBuffer();
        })
        .then(async (res) => {
          n++;
          if (l.type === "pdf") {
            const myFile = new Blob([res], { type: "application/pdf" });
            const url = URL.createObjectURL(myFile);

            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          } else {
            const myFile = new Blob([res], { type: "image/png" });
            const url = URL.createObjectURL(myFile);

            allUrls.push({ url: url, name: l.name, type: l.type, key: l.key });
          }
          if (n === num) {
            setMyState((prev) => {
              return { ...prev, urls: allUrls };
            });
            setMyState((prev) => {
              return { ...prev, loader: false };
            });
          }
        });
    });

    // setLoader(false);
  } catch (e) {
    console.log(e);
  }
};

const getInventory = async (setMyState) => {
  try {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData.access_token,
      },
    };
    const { data } = await axios.get(
      `/api/v1/${authData?.type}/plate_inventory`,
      config
    );
    const plates = data.data.data;
    setMyState((prev) => {
      return { ...prev, inventory: plates };
    });
  } catch (e) {
    console.log(e);
  }
};

const BigAvatar = styled(Avatar)`
  width: 92px;
  height: 92px;
  text-align: center;
  margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function DefaultTextFields({
  loader,
  plates,
  inventory,
  profile,
  urls,
  user,
  id,
  audits,
}) {
  const [del, setDelete] = useState(false);
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState("");
  const [update, setUpdate] = useState(false);
  const [edit, setEdit] = useState(false);
  const [prices, setPrices] = useState(plates);
  const [selectedPlates, setSelectedPlates] = useState([]);
  const [load, setLoader] = useState(false);

  const [expanded, setExpanded] = useState(profile?.default_address);

  const handleExpandedChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  const [notification, setNotification] = useState(
    profile?.notification_setting
  );
  const [message, setMessage] = useState("");
  const [modalImgHeight, setModalImgHeight] = useState(70);

  const [openModal, setOpenModal] = React.useState(false);
  const [u, setU] = useState();
  const [type, setType] = useState();
  const handleOpenModal = (url, type) => {
    setU(url);
    setType(type);
    setOpenModal(true);
    setModalImgHeight(70);
  };
  const handleCloseModal = () => setOpenModal(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const removePlate = (i, id) => {
    if (id) {
      setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    }
    setPrices((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
  };

  const priceHandle = (i, obj) => (e) => {
    let price = [...prices];
    if (obj === "plate_id") {
      price[i][obj] = e.target.value;
    } else {
      price[i][obj] = parseInt(e.target.value);
    }
    setPrices(price);
    let selected = [];
    price.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  };
  const addPrice = () => {
    setPrices((prev) => [...prev, {}]);
  };

  const updateDetails = async () => {
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${userData.type}/customer_company/${profile._id}/plate`,
        { plates: prices },
        config
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        setUpdate(false);
        setMessage("Plate Details Updated Successfully");
        snackRef.current.click();
      }
    } catch (e) {
      setLoader(false);
      setErr(e.response.data.error);
      snackRef.current.click();
    }
  };

  const handleChange = (event) => {
    setNotification({
      ...notification,
      [event.target.name]: event.target.checked,
    });
  };

  const updateNotifications = async () => {
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      const { data } = await axios.put(
        `/api/v1/${authData?.type}/customer_company/${id}/notification_setting`,
        {
          status_update_to_new: notification.status_update_to_new,
          status_update_to_studio: notification.status_update_to_studio,
          status_update_to_ctp_impose: notification.status_update_to_ctp_impose,
          status_update_to_ctp: notification.status_update_to_ctp,
          status_update_to_delivery: notification.status_update_to_delivery,
          status_update_to_customer_accept:
            notification.status_update_to_customer_accept,
          status_update_to_payment: notification.status_update_to_payment,
          status_update_to_billing: notification.status_update_to_billing,
        },
        config
      );
      if (data.success) {
        setMessage("Notification Status Updated Successfully");
        setSuccess(true);
        setErr("");
        snackRef.current.click();
      }
    } catch (e) {
      console.log(e);
    }
  };

  const formData = new FormData();
  const [openAddDoc, setOpenAdddoc] = useState(false);
  const handleDownDoc = () => {
    setOpenAdddoc(false);
    setImages({});
    setDocuments({});
  };
  const handleOpenDoc = () => {
    setOpenAdddoc(true);
  };
  const [documents, setDocuments] = useState({});
  const [images, setImages] = useState({});

  const deleteDocument = async (key) => {
    try {
      setLoader(true);
      const authData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = "";
      if (authData?.type === "customer_user") {
        url = `/api/v1/${authData?.type}/${id}/media/customer_company/${id}/${key}`;
      } else {
        url = `/api/v1/${authData?.type}/media/customer_company/${id}/${key}`;
      }
      const { data } = await axios.delete(url, config);
      if (data.success) {
        setSuccess(true);
        setErr("");
        setMessage("Document Deleted successfully");
        snackRef.current.click();
        window.location.reload();
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  const addDocuments = async () => {
    try {
      let br = 0;
      Object.values(images).map((doc, i) => {
        if (!documents[i]) {
          setErr("Document Name field cannot be empty");
          setSuccess(false);
          snackRef.current.click();
          br = 1;
          return;
        }
      });
      if (!br) {
        setLoader(true);
        const authData = JSON.parse(localStorage.getItem("AuthData"));
        Object.values(images).map((image, i) => {
          formData.set(`document_${i + 1}_file`, image);
        });
        Object.values(documents).map((doc, i) => {
          formData.set(`document_${i + 1}_name`, doc);
        });
        const config = {
          headers: {
            Authorization: "Bearer " + authData.access_token,
          },
        };
        const { data } = await axios.post(
          `/api/v1/${authData?.type}/media/customer_company/${id}`,
          formData,
          config
        );
        if (data.success) {
          setSuccess(true);
          setErr("");
          setMessage("Documents added successfully");
          snackRef.current.click();
          window.location.reload();
        }
      }
    } catch (e) {
      setErr(e.response.data.error);
      snackRef.current.click();
      setLoader(false);
      console.log(e);
    }
  };

  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open}
        onClose={handleClose}
        key={vertical + horizontal}
      >
        {err ? (
          <Alert mt={2} mb={4} severity="error">
            {err}
          </Alert>
        ) : success ? (
          <Alert mt={2} mb={4} severity="success">
            {message}
          </Alert>
        ) : null}
      </Snackbar>
      {!loader ? (
        <form>
          <form noValidate autoComplete="off">
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} lg={12} md={12}>
                      <Typography variant="h4" gutterBottom>
                        Customer Company Profile Page
                      </Typography>
                    </Grid>
                    {urls.map((url, i) => {
                      if (url.name === "profile_picture") {
                        return <BigAvatar src={url.url} />;
                      }
                    })}
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.name}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Name"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.email_address}
                        inputProps={{ readOnly: true }}
                        fullWidth
                        id="standard-required"
                        label="Email"
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.phone_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Phone Number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.landline_number}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Landline Number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        id="standard-required"
                        value={profile?.credit_sum}
                        inputProps={{ readOnly: true }}
                        label="Credit Term"
                        fullWidth
                        helperText={edit ? "Enter credit term" : null}
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        value={profile?.description}
                        inputProps={{ readOnly: true }}
                        id="standard-required"
                        label="Description"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        id="standard-required"
                        value={profile?.gst_number}
                        inputProps={{ readOnly: true }}
                        label="GST Number"
                        fullWidth
                      />
                    </Grid>
                    <Grid item xs={12} lg={12} md={12}>
                      <TextField
                        id="standard-required"
                        value={profile?.pan_number}
                        inputProps={{ readOnly: true }}
                        label="PAN Number"
                        fullWidth
                      />
                    </Grid>

                    <Grid item xs={12} lg={12} md={12}>
                      {profile?.addresses.map((address, index) => {
                        return (
                          <Accordion
                            expanded={expanded === index}
                            onChange={handleExpandedChange(index)}
                            key={index}
                          >
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls="panel1a-content"
                              id="panel1a-header"
                            >
                              <Typography>Address {index + 1}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <Grid item xs={12} lg={12} md={12}>
                                <TextField
                                  fullWidth
                                  inputProps={{ readOnly: true }}
                                  value={address.address_line_one}
                                  label={"Address Line 1"}
                                />
                              </Grid>
                              <Grid item xs={12} mt={5} lg={12} md={12}>
                                <TextField
                                  fullWidth
                                  inputProps={{ readOnly: true }}
                                  value={address.address_line_two}
                                  label={"Address Line 2"}
                                />
                              </Grid>
                              <Grid item xs={12} mt={5} lg={12} md={12}>
                                <TextField
                                  fullWidth
                                  inputProps={{ readOnly: true }}
                                  value={address.pincode}
                                  label={"Pincode"}
                                />
                              </Grid>

                              <Grid item xs={12} mt={5} md={12} lg={12}>
                                <TextField
                                  inputProps={{ readOnly: true }}
                                  label="State"
                                  value={address?.state}
                                  fullWidth
                                />
                              </Grid>

                              <Grid item xs={12} mt={5} lg={12} md={12}>
                                <TextField
                                  fullWidth
                                  inputProps={{ readOnly: true }}
                                  value={address.city}
                                  label={"City"}
                                />
                              </Grid>
                              <Grid item xs={12} mt={5} mb={5} lg={12} md={12}>
                                <FormGroup>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={
                                          index === profile?.default_address
                                        }
                                      />
                                    }
                                    label="Default Address"
                                  />
                                </FormGroup>
                              </Grid>
                            </AccordionDetails>
                          </Accordion>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </form>

          {user?.role?.permissions.includes(
            "customer_company_plate_list_view"
          ) || authData?.type === "super_admin" ? (
            <Card mb={6}>
              <CardContent>
                <form noValidate autoComplete="off">
                  <Paper elevation={3} style={{ padding: "2%" }}>
                    <Grid container spacing={5}>
                      <Grid item xs={12} lg={12} md={12}>
                        <Typography variant="h4" gutterBottom>
                          Plate Price Details
                        </Typography>
                      </Grid>
                      {!plates.length ? (
                        <Grid item xs={12} md={12} lg={12}>
                          <Typography variant="h3">No Plates Added</Typography>
                        </Grid>
                      ) : (
                        plates.map((pl, i) => {
                          const check = [];
                          if (selectedPlates.length) {
                            selectedPlates.map((p) => {
                              check.push(p);
                            });
                          }
                          return (
                            <>
                              <Grid item xs={12} md={12} lg={12}>
                                <FormControl fullWidth>
                                  <Select
                                    id="search-field"
                                    value={pl.plate_id || ""}
                                    onChange={priceHandle(i, "plate_id")}
                                    displayEmpty
                                    inputProps={{ readOnly: !update }}
                                  >
                                    <MenuItem value="" disabled>
                                      Select Plate
                                    </MenuItem>
                                    {inventory.map((plate) => {
                                      if (check.includes(plate._id)) {
                                        return (
                                          <MenuItem disabled value={plate._id}>
                                            {plate.height}X{plate.width}X
                                            {plate.thickness} ||{" "}
                                            {plate?.brand?.name} ||{" "}
                                            {plate?.technology?.name}
                                          </MenuItem>
                                        );
                                      } else {
                                        return (
                                          <MenuItem value={plate._id}>
                                            {plate.height}X{plate.width}X
                                            {plate.thickness} ||{" "}
                                            {plate?.brand?.name} ||{" "}
                                            {plate?.technology?.name}
                                          </MenuItem>
                                        );
                                      }
                                    })}
                                  </Select>
                                  <FormHelperText
                                    sx={{ color: pl.deactivated && "red" }}
                                  >
                                    {pl.deactivated === true &&
                                      "Deactivated plate"}
                                  </FormHelperText>
                                </FormControl>
                              </Grid>
                              <Grid item xs={12} lg={3} md={6}>
                                <TextField
                                  id="standard-number"
                                  label="Baking Cost"
                                  inputProps={{ readOnly: !update }}
                                  value={pl.baking_cost || ""}
                                  onChange={priceHandle(i, "baking_cost")}
                                  type="number"
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12} lg={3} md={6}>
                                <TextField
                                  id="standard-number"
                                  label="Print Cost"
                                  inputProps={{ readOnly: !update }}
                                  value={pl.print_cost || ""}
                                  onChange={priceHandle(i, "print_cost")}
                                  type="number"
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12} lg={3} md={6}>
                                <TextField
                                  id="standard-number"
                                  label="Selling Cost"
                                  inputProps={{ readOnly: !update }}
                                  value={pl.selling_cost || ""}
                                  onChange={priceHandle(i, "selling_cost")}
                                  type="number"
                                  fullWidth
                                />
                              </Grid>
                              <Grid item xs={12} lg={3} md={6}>
                                <TextField
                                  id="standard-number"
                                  label="Gripper"
                                  inputProps={{ readOnly: !update }}
                                  value={pl.gripper || ""}
                                  onChange={priceHandle(i, "gripper")}
                                  type="number"
                                  fullWidth
                                />
                              </Grid>
                            </>
                          );
                        })
                      )}
                    </Grid>
                  </Paper>
                </form>
              </CardContent>
            </Card>
          ) : null}

          <Modal open={openModal} onClose={handleCloseModal}>
            <Card sx={style}>
              <CardContent>
                <Paper>
                  <Grid container justifyContent="center" spacing={5}>
                    <Grid
                      item
                      xs={12}
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight + 5)}
                      >
                        <ZoomIn />
                      </IconButton>
                      <IconButton
                        onClick={() => setModalImgHeight(modalImgHeight - 5)}
                      >
                        <ZoomOut />
                      </IconButton>
                      <IconButton onClick={() => setModalImgHeight(70)}>
                        <RestartAlt />
                      </IconButton>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        maxHeight: "72.5vh",
                        overflowY: "scroll",
                      }}
                    >
                      {type !== "pdf" ? (
                        <Box
                          component={"img"}
                          src={u}
                          height={modalImgHeight.toString() + "vh"}
                          width="auto"
                        />
                      ) : (
                        <iframe
                          height={(modalImgHeight + 420).toString() + "vh"}
                          width={(modalImgHeight + 420).toString() + "vh"}
                          src={u}
                        />
                      )}
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          </Modal>

          <Modal
            open={openAddDoc}
            onClose={handleDownDoc}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                align="center"
                color="primary"
              >
                Add Documents
              </Typography>
              <DocumentUpload
                documents={documents}
                setDocuments={setDocuments}
                images={images}
                setImages={setImages}
              />
              <Button onClick={addDocuments}>Add</Button>
            </Box>
          </Modal>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h4" gutterBottom>
                      Document Details
                    </Typography>
                  </Grid>
                </Grid>
                {!profile.documents.length ? (
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant="h6" color="primary" gutterBottom>
                      No Documents Added
                    </Typography>
                  </Grid>
                ) : null}
                {profile.documents &&
                  profile.documents.map((document, i) => {
                    if (urls[i]?.name !== "profile_picture") {
                      return (
                        <Paper
                          style={{ display: "flex", alignItems: "center" }}
                          mt={3}
                        >
                          <Box
                            component="img"
                            width="90px"
                            height="80px"
                            onClick={() =>
                              handleOpenModal(urls[i]?.url, urls[i]?.type)
                            }
                            src={
                              urls[i]?.type === "pdf"
                                ? "/static/img/images/pdf.png"
                                : urls[i]?.url
                            }
                            style={{ cursor: "pointer" }}
                          />
                          <TextField
                            fullWidth
                            margin="dense"
                            m={2}
                            style={{ marginLeft: 32 }}
                            inputProps={{ readOnly: true }}
                            id="standard-required"
                            label="Document Name"
                            value={urls[i]?.name || ""}
                          />
                          {!del ? (
                            <Mob>
                              <Grid item>
                                <a
                                  href={urls[i]?.url}
                                  style={{
                                    color: "inherit",
                                    textDecoration: "inherit",
                                  }}
                                  download={`${urls[i]?.name}.${urls[i]?.type}`}
                                >
                                  <FileDownloadIcon
                                    style={{
                                      marginLeft: 32,
                                      cursor: "pointer",
                                    }}
                                  />
                                </a>
                              </Grid>
                            </Mob>
                          ) : (
                            <Grid item>
                              <ClearIcon
                                onClick={() => deleteDocument(urls[i]?.key)}
                                style={{
                                  marginLeft: 32,
                                  cursor: "pointer",
                                }}
                              />
                            </Grid>
                          )}
                        </Paper>
                      );
                    }
                  })}
              </Paper>
            </CardContent>
          </Card>

          {user?.role?.permissions.includes(
            "view_customer_company_audit_logs"
          ) || authData?.type === "super_admin" ? (
            <Card mb={6}>
              <CardContent>
                <Paper elevation={3} style={{ padding: "2%" }}>
                  <Grid container spacing={5}>
                    <Grid item xs={12} md={12} lg={12}>
                      <Accordion>
                        <AccordionSummary
                          expandIcon={<ExpandMore />}
                          aria-controls="panel1a-content"
                          id="panel1a-header"
                        >
                          <Typography color="primary" variant="h6" gutterBottom>
                            Audit Logs
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Grid item xs={12} md={12} lg={12}></Grid>
                          <Timeline position="alternate">
                            {audits &&
                              audits?.map((audit, ind) => {
                                return ind % 2 === 0 ? (
                                  <TimelineItem>
                                    <TimelineOppositeContent
                                      align="right"
                                      variant="body2"
                                      color="secondary"
                                    >
                                      <br />

                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format("MMM DD, YYYY")}
                                      <br />
                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format(" hh:mm A")}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                      <TimelineConnector />
                                      <TimelineDot
                                        color="primary"
                                        variant="outlined"
                                      ></TimelineDot>
                                      <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography variant="h6" component="span">
                                        {_.upperCase(audit?.audit_logs?.action)}
                                      </Typography>
                                      <Typography variant="body1">
                                        By-
                                        {audit?.audit_logs?.user_details
                                          ?.name || "Super Admin"}
                                      </Typography>
                                      <Typography variant="body2">
                                        {_.upperCase(
                                          audit?.audit_logs?.user_type
                                        ) || "SUPER ADMIN"}
                                      </Typography>
                                    </TimelineContent>
                                  </TimelineItem>
                                ) : (
                                  <TimelineItem>
                                    <TimelineOppositeContent
                                      variant="body2"
                                      color="secondary"
                                    >
                                      <br />

                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format("MMM DD, YYYY")}
                                      <br />
                                      {moment(
                                        audit?.audit_logs?.timestamp
                                      ).format(" hh:mm A")}
                                    </TimelineOppositeContent>
                                    <TimelineSeparator>
                                      <TimelineConnector />
                                      <TimelineDot color="primary"></TimelineDot>
                                      <TimelineConnector />
                                    </TimelineSeparator>
                                    <TimelineContent>
                                      <Typography variant="h6" component="span">
                                        {_.upperCase(audit?.audit_logs?.action)}
                                      </Typography>
                                      <Typography variant="body1">
                                        By-{" "}
                                        {audit?.audit_logs?.user_details
                                          ?.name || "Super Admin"}
                                      </Typography>
                                      <Typography variant="body2">
                                        {_.upperCase(
                                          audit?.audit_logs?.user_type
                                        ) || "SUPER ADMIN"}
                                      </Typography>
                                    </TimelineContent>
                                  </TimelineItem>
                                );
                              })}
                          </Timeline>
                        </AccordionDetails>
                      </Accordion>
                    </Grid>
                  </Grid>
                </Paper>
              </CardContent>
            </Card>
          ) : null}
        </form>
      ) : (
        <Loading />
      )}
    </>
  );
}

function CustomerCompanyProfile({ auths }) {
  const { company_id } = useParams();
  const navigate = useNavigate();

  const [myState, setMyState] = useState({
    loader: true,
    profile: {},
    urls: [],
    inventory: [],
    plateDetails: [],
    user: auths.user,
    audits: [],
  });

  useEffect(() => {
    getInventory(setMyState);
    getCompanyProfile(company_id, setMyState);
  }, []);
  if (!myState.loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CUSTOMER COMPANY PROFILE
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link
                component={NavLink}
                to="/dashboard/company/customer-companies"
              >
                Customer Companies
              </Link>
              <Typography>Profile </Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            <DefaultTextFields
              inventory={myState.inventory}
              plates={myState.plateDetails}
              profile={myState.profile}
              urls={myState.urls}
              user={myState.user}
              id={company_id}
              loader={myState.loader}
              audits={myState.audits}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CustomerCompanyProfile);
